import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/lib/Button';
import cx from 'classnames';

// Components.
import WelltoryLink from 'components/Welltory/Link';

// Styles.
import styles from './styles.module.scss';

export default class WelltoryButton extends PureComponent {

  static propTypes = {
    // text: PropTypes.string.isRequired,
    type: PropTypes.string,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    type: 'submit',
    disabled: false,
  };

  onClick = (e) => {
    // e ? e.preventDefault() : null;
    const { onClick } = this.props;
    if (typeof onClick === 'function') {
      onClick(e);
    }
  };

  render() {
    const { type, style, className, disabled, to, id } = this.props;
    if (type === 'link') {
      return (
        <WelltoryLink
          to={to}
          style={style}
          id={id}
          className={cx(styles.button, styles.btnDefault, className)}
          onClick={this.onClick}
        >
          {this.props.children}
        </WelltoryLink>
      );
    }
    return (
      <Button
        type={type}
        style={style}
        id={id}
        className={cx(styles.button, styles.btnDefault, className)}
        disabled={disabled}
        onClick={this.onClick}
      >
        {this.props.children}
      </Button>
    );
  }

}
